import { BaseQueryFn } from "@reduxjs/toolkit/query";
import axiosInstance from "./axiosInstance";
import { AxiosError, AxiosResponse } from "axios";
import { AxiosFetchQuery } from "../globalTypes/GlobalTypes";
import { FaqApiAbortController } from "../utils/helper";
import {
  API_CMS_FAQ_CategoryList,
  API_CMS_FAQ_List,
} from "../utils/ApiEndpoints";
// import {
//   BaseQueryMeta,
//   QueryReturnValue,
// } from "@reduxjs/toolkit/dist/query/baseQueryTypes";

const axiosBaseQuery =
  (): BaseQueryFn<AxiosFetchQuery, unknown, unknown, unknown, any> =>
  async ({ url, method, data, body, params, headers }) => {
    try {
      const rejectedUrls = [
        API_CMS_FAQ_List,
        API_CMS_FAQ_CategoryList,
      ].includes(url);
      const response: AxiosResponse<any, any> = await axiosInstance({
        url: url,
        method,
        data: data || body,
        params,
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
          ...headers,
        },
        signal: rejectedUrls
          ? FaqApiAbortController?.AbortController?.signal
          : new AbortController().signal,
      });
      // console.log(response);
      const responseUrl = response.request.responseURL;
      const config = { ...response.config };
      const meta = {
        ...response.headers,
        responseUrl: responseUrl,
        config: config,
      };

      return {
        ...response,
        meta: { ...meta },
      };
    } catch (axiosError: any) {
      const err = axiosError as AxiosError;
      const serverData = err.response?.data;
      return {
        error: {
          // spread only when server returned an object response body
          ...(serverData && typeof serverData === "object" ? serverData : {}),
          message:
            typeof serverData === "string"
              ? serverData
              : err.message || "Network Error",
          status: err.response?.status,
        },
      };
    }
  };

export default axiosBaseQuery;
